import DashboardCards from '../../../../components/DashboardCard/DashboardCards';
import ActiveUsersCard from './ActiveUsersCard';
import DailyUsersCard from './DailyActiveUsers';

export default function ActiveUsersMore(props) {
  const {
    title, error, loading, data, setRefresh, viewOption,
  } = props;

  const isDailyActiveUsers = title === 'Daily Active Users';

  return (
    <DashboardCards title={title}>
      {isDailyActiveUsers ? (
        <DailyUsersCard
          loading={loading}
          error={error}
          data={data}
          refresh={setRefresh}
          message="No Data"
          more={false}
        />
      ) : (
        <ActiveUsersCard
          loading={loading}
          error={error}
          data={data}
          more={false}
          refresh={setRefresh}
          message="No Data"
          viewOption={viewOption}
        />
      )}
    </DashboardCards>
  );
}
